import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <TopicsSection />
        <CardsSection />
        <FeaturesSection />
        <ContactSection />
        <CarouselSection />
        <FaqSection />
        <IndexSection />
        <UpdatesSection />
        <CommentsSection />
        <AppSection />
        <RankingSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}